import { CHANNEL_LAYOUT_VALUES } from '../constants/channel-layout-values';
import { CHANNEL_VIDEO_LIST_VALUES } from '../constants/channel-video-list-values';
import { COMPACT_PLAY_TYPE_VALUES } from '../constants/compact-play-type';
import { COMPACT_SHOW_VIDEO_LIST_VALUES } from '../constants/compact-show-video-list';
import { INFO_POSITION_VALUES } from '../constants/info-position-values';
import { LAYOUT_STYLE_VALUES } from '../constants/layout-style-values';
import { MAIN_ACTION_STYLE_TYPES } from '../constants/main-action-style-types';
import { MAIN_ITEM_TYPE_VALUES } from '../constants/main-item-type-values';
import { SHOW_INFO_VALUES } from '../constants/show-info-values';
import { SHOW_MEDIA_TYPE_VALUES } from '../constants/show-media-type-values';
import { TITLE_POSITION_VALUES } from '../constants/title-position-values';

/* Do not change these settings!
 *  These settings are used for old installations when we didn't save all settings
 *  and used defaults to complete them after load. Changes here can lead to unexpected changes on user's widgets  */

export const defaultSettingsV0 = {
  booleans: {
    enableVideosSharing: true,
    showChannelCategories: true,
    showChannelShare: true,
    showChannelTitle: true,
    showChannelInfo: false,
    showSearch: true,
    showSignIn: true,
    showChannelTags: true,
    showChannelVideos: true,
    showFullInfo: true,
    showVideoPublisherInList: true,
    showVideoTitleInList: true,
    showTitleForMainItem: true,
    showPublisherForMainItem: true,
    showActionBar: true,
  },
  numbers: {
    videoInfoPosition: INFO_POSITION_VALUES.ON_VIDEOS,
    showInfoAction: SHOW_INFO_VALUES.ON_MOUSE_OVER,
    layoutStyle: LAYOUT_STYLE_VALUES.SQUARE,
    channelLayout: CHANNEL_LAYOUT_VALUES.CLASSIC,
    mainItemType: MAIN_ITEM_TYPE_VALUES.CHANNEL_COVER,
    mainItemTitlePosition: TITLE_POSITION_VALUES.CENTER,
    videoListVisibility: CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
    videosInRow: 4,
    mainItemOverlayOpacity: 35,
    showMediaType: SHOW_MEDIA_TYPE_VALUES.COVER_IMAGE,
    numberOfRows: 1,
    playType: COMPACT_PLAY_TYPE_VALUES.IN_FRAME,
    compactShowVideoListType: COMPACT_SHOW_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
    mainActionStyleType: MAIN_ACTION_STYLE_TYPES.ICON_WITH_TEXT,
  },
  editMode: 'site',
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/migrations/version-0.js